export default __webpack_public_path__ + "static/media/quick_purchase_new.517bdd97.svg";